module.exports = __webpack_public_path__ + "img/anna2.0bd147fa.png";